import React from "react";
import "./Policy.css";

export default function TermsOfService() {
  return (
    <div className="policy-container">
      <h1>Terms of Service</h1>
      <p>Effective Date: April 18, 2025</p>
      <p>By using Grandmaster AI you agree to:</p>
      <ul>
        <li>All payments are final—no refunds.</li>
        <li>Use the service lawfully.</li>
        <li>Respect intellectual property.</li>
        <li>We may update terms; continued use implies acceptance.</li>
      </ul>
      <p>Questions? support@grandmasterai.com</p>
    </div>
  );
}
